import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from "primereact/accordion";
import { EmptyFilter, Filter, IEmptyFilter } from "./Filter";
import { AttendanceHistoryTable } from "./Table";
import { IPermissionProps } from "../../models/Login";

export interface IAttendaceList {
    user_ID?: number,
    user_Name?: string,
    attendance?: boolean,
    created_On?: Date,
    added_By_ID?: number,
    added_By_Name?: string,
}

export const AttendanceMark = (permissions: IPermissionProps) => {
    const [filters,setFilters] = useState<IEmptyFilter>(EmptyFilter);
    const toast = useRef<any>(null);

    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter filters={filters} setFilters={(filters: any) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            {permissions.is_View && <AttendanceHistoryTable toast={toast} filters={filters} />}
            <Toast ref={toast} />
        </>
    );
}